import classNames from 'classnames'
import { COLOUR_FACET_SWATCHES } from '@consts/colourFacets'
import { ChildFilterValue } from '../../types'
import styles from './styles.module.scss'

type ColourOptionsProps = {
  values: ChildFilterValue[]
  onSelect: (option: string) => void
}

function ColourOptions({ values, onSelect }: ColourOptionsProps) {
  return (
    <div className={styles.ColourOptions}>
      {values.map(option => {
        const swatch = COLOUR_FACET_SWATCHES[option.value]

        return (
          <button
            type="button"
            aria-pressed={option.selected}
            className={classNames(styles.ColourOptions__option, {
              [styles.isSelected]: option.selected
            })}
            disabled={!option.active}
            key={option.value}
            onClick={() => onSelect(option.value)}
          >
            <span
              aria-hidden="true"
              className={classNames(styles.ColourOptions__swatch, {
                [styles.isFallback]: !swatch,
                [styles.isWhite]: option.value.toLowerCase() === 'white'
              })}
              style={swatch ? { backgroundColor: swatch } : undefined}
            />
            <span>{option.title}</span>
          </button>
        )
      })}
    </div>
  )
}

export default ColourOptions
